import InvitationView from '@/components/login/InvitationView'
import {AlertMessages, Modal} from '@/lib/definitions'
import Vue from 'vue'
import VueRouter from 'vue-router'
import LoginView from '@/components/login/LoginView.vue'
import ValidateView from '@/components/login/ValidateView.vue'
import LandscapeView from '@/components/landscape/LandscapeView.vue'
import InfoView from '@/components/landscape/info/InfoView.vue'

const WordCloudView = () =>
  import(
    /* webpackChunkName: "wcn-wordcloud" */ './components/landscape/info/wordcloud/WordCloudView.vue'
  )

const ResetPasswordView = () =>
  import(
    /* webpackChunkName: "wcn-resetpassword" */ '@/components/login/ResetPasswordView.vue'
  )

const PremisesView = () =>
  import(
    /* webpackChunkName: "wcn-premises" */ '@/components/landscape/premises/PremisesView'
  )
const PremiseDetail = () =>
  import(
    /* webpackChunkName: "wcn-premises" */ '@/components/landscape/premises/PremiseDetail'
  )

const TopicsView = () =>
  import(
    /* webpackChunkName: "wcn-topics" */ '@/components/landscape/topics/TopicsView.vue'
  )

const Feeds = () =>
  import(
    /* webpackChunkName: "wcn-feeds" */ '@/components/landscape/feeds/Feeds.vue'
  )
const FeedsView = () =>
  import(
    /* webpackChunkName: "wcn-feeds" */ '@/components/landscape/feeds/FeedsView.vue'
  )
const FeedSources = () =>
  import(
    /* webpackChunkName: "wcn-feeds" */ '@/components/landscape/feeds/sources/FeedSources'
  )

const InsightsView = () =>
  import(
    /* webpackChunkName: "wcn-insights" */ '@/components/landscape/insights/InsightsView'
  )
const MatrixView = () =>
  import(
    /* webpackChunkName: "wcn-insights" */ '@/components/landscape/insights/matrix/MatrixView'
  )
const AxesView = () =>
  import(
    /* webpackChunkName: "wcn-insights" */ '@/components/landscape/insights/axes/AxesView'
  )
const InsightDetail = () =>
  import(
    /* webpackChunkName: "wcn-insights" */ '@/components/landscape/insights/InsightDetail'
  )

const AnalyticsView = () =>
  import(
    /* webpackChunkName: "wcn-analytics" */ '@/components/landscape/analytics/AnalyticsView.vue'
  )
const ActivityAnalysis = () =>
  import(
    /* webpackChunkName: "wcn-analytics" */ '@/components/landscape/analytics/ActivityAnalysis.vue'
  )
const UserAnalysis = () =>
  import(
    /* webpackChunkName: "wcn-analytics" */ '@/components/landscape/analytics/UserAnalysis.vue'
  )

const HomeView = () =>
  import(/* webpackChunkName: "wcn-home" */ '@/components/HomeView.vue')

const TutorialsView = () =>
  import(
    /* webpackChunkName: "wcn-home" */ '@/components/tutorials/TutorialsView.vue'
  )

const ShareView = () =>
  import(/* webpackChunkName: "wcn-home" */ '@/components/ShareView.vue')

const UnsubscribeView = () =>
  import(/* webpackChunkName: "wcn-home" */ '@/components/UnsubscribeView.vue')

const ProfileView = () =>
  import(
    /* webpackChunkName: "wcn-settings" */ '@/components/account/ProfileView.vue'
  )

const AccountView = () =>
  import(
    /* webpackChunkName: "wcn-account" */ '@/components/account/AccountView.vue'
  )

const SubscriptionViewNext = () =>
  import(
    /* webpackChunkName: "wcn-account" */ '@/components/account/SubscriptionViewNext.vue'
  )
const NotificationsView = () =>
  import(
    /* webpackChunkName: "wcn-account" */ '@/components/account/NotificationsView.vue'
  )
const UsersView = () =>
  import(/* webpackChunkName: "wcn-account" */ '@/components/account/UsersView')

const Area51 = () =>
  import(/* webpackChunkName: "wcn-area51" */ '@/components/Area51')

const SuperadminView = () =>
  import(
    /* webpackChunkName: "wcn-superadmin" */ '@/components/superadmin/SuperadminView.vue'
  )

const SettingsView = () =>
  import(
    /* webpackChunkName: "wcn-settings" */ '@/components/settings/SettingsView.vue'
  )

const InsightSettings = () =>
  import(
    /* webpackChunkName: "wcn-settings" */ '@/components/settings/InsightSettings.vue'
  )

const Labels = () =>
  import(
    /* webpackChunkName: "wcn-settings" */ '@/components/settings/Labels.vue'
  )

const Tags = () =>
  import(
    /* webpackChunkName: "wcn-settings" */ '@/components/settings/Tags.vue'
  )

const Settings = () =>
  import(
    /* webpackChunkName: "wcn-settings" */ '@/components/settings/Settings.vue'
  )

import store from './store'

Vue.use(VueRouter)

// Meta rules
const restricted = {restricted: true}
const landscape = Object.assign({landscape: true}, restricted)
const insights = Object.assign({insightsView: true}, landscape)
const settings = Object.assign({settingsSection: true, admin: true}, landscape)

const router = new VueRouter({
  // base: process.env.NODE_ENV === 'production' ? '/next/' : '',
  mode: 'history',
  routes: [
    // Redirects
    {path: '/home', redirect: {name: 'home'}},
    // Open
    {name: 'login', path: '/login', component: LoginView},
    {name: 'validate', path: '/validate', component: ValidateView},
    {
      name: 'reset-password',
      path: '/reset-password',
      component: ResetPasswordView
    },
    {name: 'invitation', path: '/invitation', component: InvitationView},
    {name: 'unsubscribe', path: '/unsubscribe', component: UnsubscribeView},
    // Restricted
    {
      name: 'home',
      path: '/home',
      meta: restricted,
      components: {default: HomeView}
    },
    {
      name: 'tutorials',
      path: '/tutorials',
      meta: restricted,
      components: {default: TutorialsView}
    },
    {
      name: 'share',
      path: '/share',
      meta: restricted,
      components: {default: ShareView}
    },
    {
      path: '/account/',
      components: {default: AccountView},
      children: [
        {
          name: 'subscription',
          path: 'subscription',
          component: SubscriptionViewNext,
          meta: restricted
        },
        {
          name: 'notifications',
          path: 'notifications',
          component: NotificationsView,
          meta: restricted
        },
        // { name: 'invoices', path: 'invoices', component: InvoicesView, meta: restricted },
        {name: 'profile', path: '', component: ProfileView, meta: restricted},
        {name: 'users', path: 'users', component: UsersView, meta: restricted}
      ]
    },
    {
      name: 'lm-admin',
      path: '/lm-admin',
      meta: restricted,
      components: {default: SuperadminView}
    },
    {
      path: '/landscape/:landscapeSlug/',
      components: {default: LandscapeView},
      children: [
        {
          path: 'settings',
          component: SettingsView,
          children: [
            {
              name: 'settings',
              path: '',
              component: Settings,
              meta: settings
            },
            {
              name: 'settings-insights',
              path: 'insights',
              component: InsightSettings,
              meta: settings
            },
            {
              name: 'tags',
              path: 'tags',
              component: Tags,
              meta: settings
            },
            {
              name: 'labels',
              path: 'labels',
              component: Labels,
              meta: settings
            }
          ]
        },
        {
          path: 'premises',
          component: PremisesView,
          children: [
            {
              name: 'premise',
              path: 'detail/:premiseSlug/:actor*',
              component: PremiseDetail,
              meta: landscape
            },
            {
              name: 'premises',
              path: ':actor*',
              meta: landscape
            }
          ]
        },
        {
          name: 'topics',
          path: 'topics/:actor*',
          component: TopicsView,
          meta: landscape
        },
        {
          path: 'feeds',
          component: FeedsView,
          children: [
            {
              name: 'feed-sources',
              path: 'sources/:actor*',
              component: FeedSources,
              meta: landscape
            },
            {
              name: 'feeds',
              path: ':actor*',
              component: Feeds,
              meta: landscape
            }
          ]
        },
        {
          path: 'insights',
          component: InsightsView,
          children: [
            {
              name: 'axes',
              path: 'axes',
              component: AxesView,
              meta: insights,
              children: [
                {
                  name: 'axes-insight',
                  path: ':insightSlug',
                  component: InsightDetail,
                  meta: insights
                }
              ]
            },
            {
              name: 'insights',
              path: '',
              component: MatrixView,
              meta: insights,
              children: [
                {
                  name: 'insight',
                  path: ':insightSlug',
                  component: InsightDetail,
                  meta: insights
                }
              ]
            }
          ]
        },
        {
          name: 'analytics',
          path: 'analytics/',
          component: AnalyticsView,
          children: [
            {
              name: 'user-analysis',
              path: 'users/:actor*',
              component: UserAnalysis,
              meta: landscape
            },
            {
              name: 'activity-analysis',
              path: ':actor*',
              component: ActivityAnalysis,
              meta: landscape
            }
          ]
        },
        {
          path: '',
          component: InfoView,
          children: [
            {
              name: 'wordcloud',
              path: 'wordcloud/:actor*',
              component: WordCloudView,
              meta: landscape
            },
            {name: 'info', path: ':actor*', meta: landscape}
          ]
        },
        {path: 'area51/:actor*', component: Area51, meta: landscape}
      ]
    },
    // catch all redirect
    {
      path: '*',
      redirect: () => {
        if (!store.getters.userIsLogged) {
          return 'login'
        } else {
          console.log('catch all redirect')
          return store.getters.startPage === 'home'
            ? '/home'
            : `/landscape/${store.getters.startPage}`
        }
      }
    }
  ]
})

// Check authentication
router.beforeEach((to, from, next) => {
  console.groupCollapsed(`Router. To ${to.name}`)
  console.log(`Is restricted? ${to.meta.restricted}`)
  console.log(`Is admin? ${to.meta.admin}`)
  console.log(`Are you logged? ${store.getters.userIsLogged}`)
  console.log(`Is trial expired? ${store.getters.isTrialExpired}`)
  console.log(`Is Plan NOT Valid? ${store.getters.isPlanNotValid}`)
  if (!store.getters.userIsLogged) {
    if (to.meta.restricted) {
      next({name: 'login', query: {returnURL: to.path}})
    } else {
      console.log('Continue...')
      next()
    }
  } else {
    // userIsLogged
    if (
      (store.getters.isTrialExpired || store.getters.isPlanNotValid) &&
      to.name !== 'subscription' &&
      to.name !== 'users'
    ) {
      // avoid infinite redirect loops
      console.log('Redirect to account/subscription')
      next('/account/subscription')
      return
    }

    // Landscape guards
    checkGuard(
      to.meta.admin,
      store.getters.hasAdminRightsSlug(to.params.landscapeSlug),
      next
    )
    checkGuard(to.name === 'wordcloud', store.getters.allowedToWordcloud, next)

    // Else
    if (
      to.meta.restricted ||
      to.name === 'unsubscribe' ||
      to.name === 'invitation'
    ) {
      console.log('Continue...')
      next()
    } else {
      // TODO: APP-566 but why
      console.log('Redirect to landscape or home')
      next('/')
    }
  }
})

// Prevent closing modal with unsaved changes
window.addEventListener('beforeunload', function(event) {
  if (
    store.getters.userIsLogged &&
    store.getters.isModalDirty &&
    store.getters.isDirtyAux
  ) {
    event.returnValue = ''
  }
})
function resetAndcontinue(next) {
  store.dispatch('unsetDirty')
  store.dispatch('unsetDirtyAux')
  next()
}
function checkGuard(condition, allow, next) {
  if (condition) {
    if (allow) return next()
    return next('/home') // abort
  }
}
router.beforeEach((to, from, next) => {
  if (!store.getters.isModalDirty && !store.getters.isDirtyAux) next()
  else {
    // Edge cases:
    if (!store.getters.userIsLogged) {
      // 1. Unrestricted pages (login, remember...)
      resetAndcontinue(next)
      return
    } else if (
      (from.query.modal && from.query.modal === to.query.modal) ||
      to.query.submodal === Modal.EDITOR_HELP ||
      from.query.submodal === Modal.EDITOR_HELP
    ) {
      // 2. Navigation to submodal (new Insight > Connect topic)
      next()
      return
    }
    const answer = window.confirm(AlertMessages.MODAL_DIRTY)
    if (!answer) {
      next(false)
    } else {
      resetAndcontinue(next)
    }
  }
})

// Extend Router
router.pushQuery = query => {
  router.push({query: {...router.currentRoute.query, ...query}}).catch(() => {})
}
router.removeKeyFromQuery = key => {
  let q = Object.assign({}, router.currentRoute.query)
  delete q[key]
  // Add catch https://github.com/vuejs/vue-router/issues/2872
  router.push({query: q}).catch(() => {})
}

// Add testing views
if (process.env.NODE_ENV !== 'production') {
  router.afterEach(() => {
    console.groupEnd()
  })
  router.addRoute({
    name: 'area51',
    path: '/area51',
    meta: restricted,
    components: {default: Area51}
  })
  // TODO Add area51 to Landscape route dynamically
}

export default router
